/**
 * Readiness filter logic for directory employees. Extracted to reduce cognitive complexity.
 */

import { getReadinessBand, READINESS_BANDS } from "@components/ReadinessCircle/readinessBand.js";

export const READINESS_FILTER = {
  NO_FILTER: "no_filter",
  DEVELOPING: "developing",
  COMPETENT: "competent",
  EXPERT: "expert",
};

const FILTER_TO_BAND = {
  developing: READINESS_BANDS.DEVELOPING,
  competent: READINESS_BANDS.COMPETENT,
  expert: READINESS_BANDS.EXPERT,
};

/**
 * Returns true if employee's current_readiness matches the given filter value.
 * @param {{ current_readiness?: number }} employee
 * @param {string} filterValue - one of READINESS_FILTER values or display labels
 * @returns {boolean}
 */
export function matchesReadinessFilter(employee, filterValue) {
  const readiness = Number(employee?.current_readiness);
  const label = String(filterValue || "").toLowerCase();

  const band = FILTER_TO_BAND[label];
  if (!band) return true;
  return Number.isFinite(readiness) && getReadinessBand(readiness) === band;
}
